import { Status } from '../../../Status'

import * as styles from './EmailProfileWidgetCustomFoldersItem.module.css'

function EmailProfileWidgetCustomFoldersItem({
  className = styles.EmailProfileWidgetCustomFoldersItem,
  ...restProps
}) {
  return (
    <div className={className}>
      <Status {...restProps} />
    </div>
  )
}

export default EmailProfileWidgetCustomFoldersItem
